import { VerifiedIncomeAdjustedActivity } from "../types";
import { getFullName } from "shared/utils/get-full-name";
import { formatToCurrency } from "shared/utils";

interface IncomeAdjustmentViewProps {
  activityItem: VerifiedIncomeAdjustedActivity;
}

export const IncomeAdjustmentView = ({
  activityItem
}: IncomeAdjustmentViewProps) => {
  return (
    <div>
      <p className="text-base font-bold text-content-1000">
        Income updated for{" "}
        <span className="font-normal">
          {getFullName({
            firstName: activityItem.details.contact.first_name,
            lastName: activityItem.details.contact.last_name,
            middleName: activityItem.details.contact.middle_name,
            short: true
          })}
        </span>
      </p>
      <div className="mt-1 text-sm text-content-400">
        {/* Only show gross if it changed */}
        {activityItem.details.original_income.gross_monthly_income.cents !==
        activityItem.details.adjusted_income.gross_monthly_income.cents ? (
          <p>
            Previous gross income: [
            {formatToCurrency(
              activityItem.details.original_income.gross_monthly_income
            )}
            ] • New gross income: [
            {formatToCurrency(
              activityItem.details.adjusted_income.gross_monthly_income
            )}
            ]
          </p>
        ) : null}
        {/* Only show net if it changed */}
        {activityItem.details.original_income.net_monthly_income.cents !==
        activityItem.details.adjusted_income.net_monthly_income.cents ? (
          <p>
            Previous net income: [
            {formatToCurrency(
              activityItem.details.original_income.net_monthly_income
            )}
            ] • New net income: [
            {formatToCurrency(
              activityItem.details.adjusted_income.net_monthly_income
            )}
            ]
          </p>
        ) : null}
      </div>
    </div>
  );
};
